import { render, staticRenderFns } from "./DialogAddCoverage.vue?vue&type=template&id=b8ebfc24"
import script from "./DialogAddCoverage.vue?vue&type=script&lang=js"
export * from "./DialogAddCoverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports